import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

// Each row: a screenshot paired with its description. Rows alternate sides.
const SECTIONS = [
  {
    img: "/create-tournament.png",
    title: "Flexible brackets",
    text: "Build single or double elimination brackets for any number of players. Byes are inserted and resolved automatically, and double elimination includes a proper losers bracket and grand-final reset.",
  },
  {
    img: "/tournament-bracket-view.png",
    title: "Live results in real time",
    text: "Click winners as matches finish. Every result updates player records and Elo ratings instantly, and the bracket advances automatically as players move through it.",
  },
  {
    img: "/view-each-player-record.png",
    title: "Player records",
    text: "Each player has a full match history — opponents, wins, losses, and the tournaments they played in. Click any name in a bracket to see their record.",
  },
  {
    img: "/player-list.png",
    title: "Ratings & seeding",
    text: "Turn on Elo ratings to rank your players. Seeded brackets then spread the strongest apart so the best matchups happen late — re-shuffle anytime and seeded players stay put.",
  },
  {
    img: "/tournament-list.png",
    title: "Your tournament history",
    text: "Every tournament you run is saved with its winner and runner-up. Reopen any completed event to view its full bracket again whenever you like.",
  },
  {
    img: "/compare-player-performance.png",
    title: "Statistics",
    text: "Compare any set of players on a rating-over-time graph. Lines start when a player joins and end when they stop competing, so the chart reflects real activity.",
  },
];

function ProductPage() {
  const { session } = useAuth();

  return (
    <div className="mk-product">
      <header className="mk-page-head">
        <h1 className="mk-page-title">Everything you need to run a bracket</h1>
        <p className="mk-page-sub">
          From a quick pickup tournament to a seeded double-elimination event,
          Tournament City has the tools.
        </p>
      </header>

      <div className="mk-prod-rows">
        {SECTIONS.map((s, i) => (
          <div
            key={s.title}
            className={`mk-prod-row${i % 2 === 1 ? " reverse" : ""}`}
          >
            <div className="mk-prod-shot">
              <img src={s.img} alt={s.title} loading="lazy" />
            </div>
            <div className="mk-prod-copy">
              <h3 className="mk-prod-title">{s.title}</h3>
              <p className="mk-prod-text">{s.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mk-cta">
        <Link to={session ? "/app" : "/sign-in"} className="mk-btn-primary">
          {session ? "Open the App" : "Get Started"}
        </Link>
      </div>
    </div>
  );
}

export default ProductPage;
